// extracted by mini-css-extract-plugin
export var textClass = "PullQuote-module--textClass--2hQ9E";
export var blockquoteClass = "PullQuote-module--blockquoteClass--ouj4v";
export var quoteClass = "PullQuote-module--quoteClass--QbL4Q";
export var authorClass = "PullQuote-module--authorClass--+bevF";
export var iconClass = "PullQuote-module--iconClass--dqzRX";
export var rightIconClass = "PullQuote-module--rightIconClass--DthH8";